export default "__VITE_ASSET__BEl74YIt__"